(() => {
  const menu = document.getElementById('menu');
  const nav = document.getElementById('navigation');
  if (menu && nav) {
    const mobile = window.matchMedia('(max-width: 760px)');
    const groups = [...nav.querySelectorAll('.rad-nav-group')];
    const setOpen = (open) => {
      menu.setAttribute('aria-expanded', String(open));
      nav.hidden = !open;
      nav.classList.toggle('open', open);
      nav.classList.toggle('collapsed', !open);
    };
    const setGroups = () => groups.forEach(group => { group.open = !mobile.matches; });
    setOpen(false);
    setGroups();
    menu.addEventListener('click', () => setOpen(menu.getAttribute('aria-expanded') !== 'true'));
    mobile.addEventListener('change', () => { setOpen(false); setGroups(); });
    nav.querySelectorAll('a').forEach(link => link.addEventListener('click', () => setOpen(false)));
    document.addEventListener('keydown', event => { if (event.key === 'Escape' && menu.getAttribute('aria-expanded') === 'true') { setOpen(false); menu.focus(); } });
  }
  const ticker = document.querySelector('.ticker');
  const toggle = document.getElementById('tickerToggle');
  if (ticker && toggle) toggle.addEventListener('click', () => {
    const paused = ticker.classList.toggle('paused');
    toggle.setAttribute('aria-pressed', String(paused));
    toggle.setAttribute('aria-label', paused ? 'Resume scrolling banner' : 'Pause scrolling banner');
    toggle.textContent = paused ? 'Play' : 'Ⅱ';
  });
})();
